import api from "api/api";

export const createProspectionQuery = async (data) =>
  await api.post("/directory/prospection", data);

export const getProspectionByUserIdQuery = async ({ id, scope }) =>
  await api.get(`/directory/prospection/user/${id}?scope=${scope}`);

export const getProspectionByClientAndProspectionIdsQuery = async ({
  client_ids,
  prospection_ids,
  userScope,
}) =>
  await api.get(
    `/directory/prospection?scope=${userScope}&client_ids=${client_ids}&prospection_ids=${prospection_ids}`
  );

export const detachProspectionQuery = async ({ id, scope }) =>
  await api.post(`/directory/prospection/${id}/detach?scope=${scope}`);

export const updateProspectionSectorQuery = async ({ id, sector_id }) =>
  await api.patchTextPlain(`/directory/prospection/${id}/sector`, sector_id);

export const updateProspectionTrafficLightQuery = async ({
  id,
  traffic_light_value,
}) =>
  await api.patchTextPlain(
    `/directory/prospection/${id}/light`,
    traffic_light_value
  );
